var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2706 4H4.29347C3.86689 4 3.63622 4.49985 3.91302 4.82444L10.2614 12.2687C10.3385 12.3592 10.3809 12.4743 10.3809 12.5932V19.5767C10.3809 19.9879 10.8498 20.2233 11.1796 19.9776L13.3134 18.388C13.44 18.2936 13.5147 18.145 13.5147 17.987V12.5859C13.5147 12.4714 13.554 12.3604 13.626 12.2714L19.6593 4.8145C19.9239 4.48757 19.6912 4 19.2706 4Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c2aef2541ce24b7f86d0a3542c167c7f.svg";
export { ForwardRef as ReactComponent };